import { render, staticRenderFns } from "./PatientResultsGeneralInterpretations.vue?vue&type=template&id=036c6ad2&scoped=true&"
import script from "./PatientResultsGeneralInterpretations.vue?vue&type=script&lang=ts&"
export * from "./PatientResultsGeneralInterpretations.vue?vue&type=script&lang=ts&"
import style0 from "./PatientResultsGeneralInterpretations.vue?vue&type=style&index=0&id=036c6ad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036c6ad2",
  null
  
)

export default component.exports